import React from "react";
import { HashRouter as Router, Route, Routes as ReactRoutes } from 'react-router-dom';

import Dashboard from '../src/page/Dashboard';
import AcceptanceTerm from '../src/page/AcceptanceTerm';

const Routes = () => (
    <Router>
        <ReactRoutes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/AcceptanceTerm/:benefitId/:cardHolderNumber/:quizId" element={<AcceptanceTerm />} />
        </ReactRoutes>
    </Router>
);

export default Routes;